import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "\u8BBE\u7F6E"
});
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.0106 16.139C10.0619 16.139 8.48203 14.5593 8.48203 12.6104C8.48203 10.6615 10.0619 9.08188 12.0106 9.08188C13.9592 9.08188 15.5391 10.6617 15.5391 12.6104C15.5391 14.5593 13.9592 16.139 12.0106 16.139ZM18.0383 9.84707C17.9682 9.65111 17.8913 9.46208 17.8073 9.27998L19.2775 7.32668C19.4619 7.07569 19.4352 6.72745 19.2145 6.50755L17.5132 4.80629C17.2933 4.58575 16.9451 4.55887 16.6941 4.74328L14.7408 6.21351L14.1737 5.98247L13.8377 3.54609C13.7952 3.23125 13.5253 2.99728 13.2076 3.00001H10.8132C10.4956 2.99728 10.2253 3.23125 10.1831 3.54609L9.84705 5.98247L9.27997 6.21351L7.32667 4.74328C7.07547 4.55887 6.72745 4.58575 6.50754 4.80629L4.80629 6.50755C4.58575 6.72745 4.55887 7.07569 4.74328 7.32668L6.2135 9.27998C6.12949 9.46208 6.05241 9.65111 5.98246 9.84707L3.54609 10.1831C3.23125 10.2255 2.99707 10.4956 3.00001 10.8132V13.2076C2.99707 13.5254 3.23125 13.7953 3.54609 13.8377L5.96146 14.1737C6.0314 14.3697 6.10848 14.5587 6.1925 14.7408L4.72227 16.6941C4.53786 16.9451 4.56475 17.2933 4.78528 17.5133L6.48654 19.2145C6.70645 19.435 7.05468 19.4619 7.30567 19.2775L9.25897 17.8073L9.82605 18.0383L10.1621 20.4537C10.2043 20.7685 10.4746 21.0027 10.7922 20.9998H13.2076C13.5253 21.0027 13.7952 20.7685 13.8377 20.4537L14.1737 18.0383L14.7408 17.8073L16.6941 19.2775C16.9451 19.4619 17.2933 19.435 17.5132 19.2145L19.2145 17.5133C19.4352 17.2933 19.4619 16.9451 19.2775 16.6941L17.8073 14.7408C17.8913 14.5587 17.9682 14.3697 18.0383 14.1737L20.4537 13.8377C20.7685 13.7953 21.0025 13.5254 20.9998 13.2076V10.8132C21.004 10.5026 20.7811 10.235 20.4747 10.1831L18.0383 9.84707Z",
  fill: "#BDC3CD"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var __ = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { __ as default };
